//Journeys
import AllMySons from './all-my-sons.json';
import AMSEmployee from './ams-employee.json';
import Customer from './customer.json';
import CustomerFacing from './customer-facing.json';

const journeysLibrary: any = {
	"AllMySons": AllMySons,
	"AMSEmployee": AMSEmployee,
	"Customer": Customer,
	"CustomerFacing": CustomerFacing
}

export default journeysLibrary;